import type { CardPayment, CreditCard } from "@b2bportal/card-api";
import type { Payment, PaymentOpaqueValue } from "@b2bportal/purchase-api";
import type { PartialParentContext, ParentState } from "@checkout/types";
import type { ErrorCode, TokenizeCardErrors } from "@hopper-b2b/types";
import type { RequiredField } from "@hopper-b2b/utilities";

export interface ICardPayment extends PaymentOpaqueValue {
  type: typeof Payment.Card;
  value: CardPayment;
}

export type ParentContextWithCardPayment = RequiredField<
  PartialParentContext,
  ParentState.cardPayment
>;

export enum PaymentErrorModalTypes {
  ListPaymentMethods = "ListPaymentMethods",
  VerifyPayment = "VerifyPayment",
  CardDeclined = "CardDeclined",
  ExcessiveUserActivity = "ExcessiveUserActivity",
  GenericError = "GenericError",
  DeletePayment = "DeletePayment",
}

export interface PaymentError {
  type: PaymentErrorModalTypes;
  data: ErrorCode[] | TokenizeCardErrors[];
  paymentMethods?: CreditCard[];
}
